<template>
  <a
    class="button"
    href="#!"
    @click.prevent="bookViewing"
  ><slot /></a>
</template>
<script>
import { eventBus } from '../app';

export default {
	props: {
		product: {
			type: [Object, Boolean], 
			default: false
		},
		type: { 
			type: String,
			default: ''
		},
		postcode: { 
			type: String,
			default: ''
		},
		project: {
			type: Number,
			default: null
		},
		stockist: {
			type: [Object, Boolean], 
			default: false
		}
	},
	data() {
		return {
			selectedProduct: this.product,
			itemType: this.type
		};
	},
	methods: {
		bookViewing() {
			eventBus.$emit('book-viewing', { type: this.type, item: this.selectedProduct, postcode: this.postcode, project: this.project, stockist: this.stockist });
		}
	}
};
</script>
